<template>
  <div class="legal-page">
    <h1 class="legal-title">Mentions légales</h1>

    <section class="legal-section">
      <h2 class="legal-subtitle">Éditeur du site</h2>
      <p>
        CrossFit Event Scanner est un service indépendant d'agrégation et de
        référencement d'événements CrossFit en France, édité à titre personnel.
      </p>
      <!-- <p>Contact : <a href="mailto:rob.fermaud@gmail.com">rob.fermaud@gmail.com</a></p> -->
    </section>

    <section class="legal-section">
      <h2 class="legal-subtitle">Hébergement</h2>
      <p>
        Le site est hébergé par <strong>Vercel Inc.</strong>, 340 Pine Street,
        Suite 701, San Francisco, CA 94104, États-Unis.
      </p>
    </section>

    <section class="legal-section">
      <h2 class="legal-subtitle">Propriété intellectuelle</h2>
      <p>
        L'ensemble du contenu de ce site (structure, textes, code) est protégé
        par le droit d'auteur. Les informations relatives aux événements
        sportifs sont issues de sources publiques et restent la propriété de
        leurs organisateurs respectifs.
      </p>
    </section>

    <section class="legal-section">
      <h2 class="legal-subtitle">Limitation de responsabilité</h2>
      <p>
        Les informations présentées sur ce site sont fournies à titre
        informatif. CrossFit Event Scanner ne peut garantir l'exactitude,
        l'exhaustivité ou l'actualité des données affichées. En cas de doute,
        veuillez contacter directement l'organisateur de l'événement.
      </p>
    </section>
  </div>
</template>

<script setup lang="ts">
definePageMeta({ layout: 'search' });
useSeoMeta({
  title: 'Mentions légales — CrossFit Event Scanner',
  robots: 'noindex',
});
</script>
